<template>
  <div class="rpg-pd-5">
    <div class="rpg-pd-5-10 rpg-bd-b rpg-pr-title">
      <span class="rpg-label">{{ project.客户公司 }}-{{ project.项目名称 }}</span>
      <span class="rpg-gray">（当前项目）</span>
    </div>
    <div class="rpg-pd-5-10 rpg-label">
      推荐反馈
      <div
        class="rpg-icon-right rpg-pdt-5 rpg-pointer el-icon-arrow-down"
        :class="isFold ? 'el-icon-arrow-right' : 'el-icon-arrow-down'"
        @click="isFold = !isFold"
      ></div>
    </div>
    <div v-show="!isFold">
      <div class="rpg-bd rpg-pd-5-10 rpg-mgb-5">
        <div class="rpg-tag-green">候选人</div>
        <div class="rpg-pd-5">
          <label>人选意愿：</label>
          <el-radio v-model="yiyuan" label="非常积极">非常积极</el-radio>
          <el-radio v-model="yiyuan" label="积极">积极</el-radio>
          <el-radio v-model="yiyuan" label="犹豫">犹豫需要推动</el-radio>
          <el-radio v-model="yiyuan" label="放弃">人选放弃</el-radio>
        </div>
        <div class="rpg-pd-5">
          <div>反馈问题：</div>
          <el-input
            type="textarea"
            rows="3"
            v-model="radishFeedback"
            placeholder="填写候选人对于客户提出问题的反馈说明；"
          ></el-input>
          <el-checkbox v-model="sendWxRadish">发送微信消息通知客户经理</el-checkbox>
        </div>
        <div class="rpg-pd-5 rpg-text-right">
          <el-button size="mini" type="primary" @click="handleConfirmRadish">提交反馈</el-button>
        </div>
      </div>
      <div class="rpg-bd rpg-pd-5-10">
        <div class="rpg-tag-green">客户&客户经理</div>
        <div class="rpg-pd-5">
          <label>简历筛选结果：</label>
          <el-radio v-model="result" label="合适">合适</el-radio>
          <el-radio v-model="result" label="淘汰">不合适（人选淘汰）</el-radio>
          <el-radio v-model="result" label="待定">待定</el-radio>
        </div>
        <div class="rpg-pd-5">
          <div>反馈问题：</div>
          <el-input
            type="textarea"
            rows="3"
            v-model="clientFeedback"
            placeholder="填写客户&客户经理对于推荐人选的反馈以及疑问；"
          ></el-input>
          <el-checkbox v-model="sendWxClient">发送微信消息通知顾问</el-checkbox>
        </div>
        <div class="rpg-pd-5 rpg-text-right">
          <el-button size="mini" type="primary" @click="handleConfirmClient">提交反馈</el-button>
        </div>
      </div>
    </div>
    <div class="rpg-pd-5 rpg-bd-t">
      <div v-for="(feed, k) in feedbacks" :key="k">
        <div>
          <span class="rpg-gray rpg-mgr-5">{{ feed.时间 }}&nbsp;&nbsp;--{{ feed.顾问 }}</span>
          <span class="rpg-tag-green-sm">{{ feed.类型 }}</span>
        </div>
        <div>
          <pre class="rpg-pre"><i class="el-icon-warning"></i>{{ feed.内容 }}</pre>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
const dateFormat = require('dateformat')
export default {
  props: {
    radish: {
      type: Object,
    },
    project: {
      type: Object,
    },
    onConfirm: {
      type: Function,
      default: function() {},
    },
  },
  data() {
    return {
      result: '合适',
      yiyuan: '非常积极',
      clientFeedback: '',
      radishFeedback: '',
      sendWxClient: true,
      sendWxRadish: true,
      rid: '',
      pid: '',
      recommend: {},
      feedbacks: [],
      isFold: false,
    }
  },
  async mounted() {
    this.rid = this.radish.rid || this.radish._id
    this.pid = this.project._id
    const res = await app.service('radish').findRecommend({ rid: this.rid, pid: this.pid })
    if (res.status == 'success') {
      if (res.data.length > 0) {
        this.recommend = res.data[0]
        if (res.data[0].推荐反馈) {
          this.setFeedbacks(res.data[0].推荐反馈)
        }
        this.clientFeedback = ''
        this.radishFeedback = ''
        this.result = '合适'
        this.yiyuan = '非常积极'
        this.sendWxClient = true
        this.sendWxRadish = true
      } else {
        this.$message.error('未找到对应推荐数据')
      }
    } else {
      this.$message.error(res.msg)
    }
  },
  methods: {
    async handleConfirmClient() {
      const dt = {
        结果: this.result,
        客户经理反馈: this.clientFeedback,
        sendWx: this.sendWxClient,
      }
      const res = await app.service('radish').addFeedback({ _id: this.recommend._id, data: dt, type: 'recommend' })
      if (res.status == 'success') {
        this.setFeedbacks(res.data.推荐反馈)
        this.clientFeedback = ''
        this.result = '合适'
        this.sendWxClient = true
        this.onConfirm()
        this.$message.success('操作成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    async handleConfirmRadish() {
      const dt = {
        人选意愿: this.yiyuan,
        候选人反馈: this.radishFeedback,
        sendWx: this.sendWxRadish,
      }
      const res = await app.service('radish').addFeedback({ _id: this.recommend._id, data: dt, type: 'recommend' })
      if (res.status == 'success') {
        this.setFeedbacks(res.data.推荐反馈)
        this.radishFeedback = ''
        this.yiyuan = '非常积极'
        this.sendWxRadish = true
        this.onConfirm()
        this.$message.success('操作成功')
      } else {
        this.$message.error(res.msg)
      }
    },
    setFeedbacks(feedbacks) {
      this.feedbacks = feedbacks
        .map(f => {
          f.时间 = dateFormat(f.时间, 'yyyy-mm-dd HH:MM')
          return f
        })
        .sort((a, b) => (a.时间 < b.时间 ? 1 : -1))
    },
  },
}
</script>
<style>
@import '../../static/css/progress.css';
</style>
